import { render, staticRenderFns } from "./deleteApplyRoomDiscountType.vue?vue&type=template&id=57c630b5&scoped=true"
import script from "./deleteApplyRoomDiscountType.vue?vue&type=script&lang=js"
export * from "./deleteApplyRoomDiscountType.vue?vue&type=script&lang=js"
import style0 from "./deleteApplyRoomDiscountType.vue?vue&type=style&index=0&id=57c630b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c630b5",
  null
  
)

export default component.exports